module.exports = __webpack_public_path__ + "static/media/IMG_1537.4d6e89bf.jpg";